import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import WizardService from "@/services/wizard.service";
import ShiftService from "@/services/shift.service";
import { AxiosError } from "axios";
import { PositionDto } from "@/types/position.type";
import { WizardStep } from "@/types/enums.type";
import { WizardFormDto, WizardHourFormDto, WizardInformationFormDto, WizardPayrollFormDto, WizardRateFormDto, WizardSchedulerFormDto } from "@/types/wizard.type";

@Module({ namespaced: true })
class Wizard extends VuexModule {
  errorMessage = "";
  isLoading = false;
  currentStep = WizardStep.Welcome;
  positions: PositionDto[] = [];
  infoForm: WizardInformationFormDto = new WizardInformationFormDto();
  schedulerForm: WizardSchedulerFormDto | null = new WizardSchedulerFormDto();
  rateForms: WizardRateFormDto[] = [];
  payrollForm: WizardPayrollFormDto = new WizardPayrollFormDto();
  hourForms: WizardHourFormDto[] = [
    { day: "Monday", break: "0", start: "08:00", end: "17:00" },
    { day: "Tuesday", break: "0", start: "08:00", end: "17:00" },
    { day: "Wednesday", break: "0", start: "08:00", end: "17:00" },
    { day: "Thursday", break: "0", start: "08:00", end: "17:00" },
    { day: "Friday", break: "0", start: "08:00", end: "17:00" },
    { day: "Saturday", break: "", start: "", end: "" },
    { day: "Sunday", break: "", start: "", end: "" }
  ];

  @Action({ rawError: true })
  async getPositions(): Promise<PositionDto[]> {
    try {
      const positions = await ShiftService.getPositionsAsync();

      this.context.commit("updateField", {
        path: "positions",
        value: positions
      });
    } catch (e) {
      console.error(e);
    }
    return [];
  }

  @Action({ rawError: true })
  async validateUsername(username: string): Promise<void> {
    try {
      this.context.commit("updateField", {
        path: "errorMessage",
        value: null
      });
      return await WizardService.validateUsernameAsync(username)
    } catch (e: unknown) {
      const errorMessage = (e as AxiosError).response?.data.message;
      this.context.commit("updateField", {
        path: "errorMessage",
        value: errorMessage
      });
    }
  }

  @Action({ rawError: true })
  async finish(): Promise<boolean> {
    try {
      const hours = this.hourForms.map(hour => ({
        day: hour.day ? hour.day : null,
        start: hour.start ? hour.start : null,
        end: hour.end ? hour.end : null,
        break: hour.break ? hour.break : null
      } as WizardHourFormDto));

      const form: WizardFormDto = {
        information: this.infoForm,
        scheduler: this.schedulerForm,
        hours: hours,
        rates: this.rateForms,
        payroll: this.payrollForm
      }

      await WizardService.finishAsync(form);
      
      return true;
    } catch (e: unknown) {
      console.error(e);
      return false;
    }
  }
}

Wizard.getters = { getField };
Wizard.mutations = { updateField };

export default Wizard;